import gatewayService from '@/modules/common/services/gatewayService';

const BASE = 'v3/online_presence/ai_chat_configurations';

/**
 * Get the main AI chat configuration for the authenticated business.
 * Returns null when none exists (404).
 * @returns {Promise<object|null>} AI chat config blob or null
 */
async function getMainConfig() {
  try {
    const res = await gatewayService.get(`${BASE}/main`);
    const data = res?.data?.data ?? res?.data;
    return data ?? null;
  } catch (err) {
    if (err?.response?.status === 404) {
      return null;
    }
    throw err;
  }
}

/**
 * Upsert the main AI chat configuration for the authenticated business.
 * Merges provided fields with existing values on the server.
 * @param {object} payload - Partial config fields to upsert
 * @returns {Promise<object>} Updated AI chat config
 */
async function upsertMainConfig(payload) {
  const res = await gatewayService.put(`${BASE}/main`, payload || {});
  const data = res?.data?.data ?? res?.data;
  return data ?? null;
}

export default {
  getMainConfig,
  upsertMainConfig,
};
